import { useState } from 'react';
import TradeablesManager from './TradeablesManager';
import MatchesTab from './MatchesTab';
import ProposalsTab from './ProposalsTab';

// Trades hub. Phase 3 ships the "For Trade" tab; Matches (Phase 4) and
// Proposals (Phase 5) slot into the same tab bar.
const TABS = [
  { key: 'matches', label: 'Matches' },
  { key: 'forTrade', label: 'For Trade' },
  { key: 'proposals', label: 'Proposals' }
];

const TradesView = () => {
  const [activeTab, setActiveTab] = useState('matches');

  return (
    <div className="px-4 md:px-10 py-6 max-w-4xl mx-auto">
      <h2 className="font-heading font-bold text-xl text-ink-primary mb-4">Trades</h2>

      <div className="flex gap-1 bg-cream-card border border-border rounded-xl p-1 mb-6 max-w-md">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`flex-1 py-2 rounded-lg text-[13px] font-semibold transition-colors ${
              activeTab === tab.key
                ? 'bg-navy-dark text-white'
                : 'text-ink-secondary hover:text-ink-primary'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'forTrade' && <TradeablesManager />}

      {activeTab === 'matches' && <MatchesTab />}

      {activeTab === 'proposals' && <ProposalsTab />}
    </div>
  );
};

export default TradesView;
